import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiGetConsecutivos, getConsById, apiSaveCons } from "../api/consecutivoApi";
import empresaApi from "../api/empresaApi";

export const useConsecutivo = () => {
  const [consecutivos, setCons] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCons, setSelectedCons] = useState(null);
  const [inactiveCons, setInactiveCons] = useState(false);

  const [form, setForm] = useState({
    id: "",
    Consecutivo: "",
    api: "",
    orden: "",
    estado: 1,
    resultado: 0,
    id_empresa: 0,
  });

  // ---- Load Consecutivo ----
  const loadCons = async () => {
    try {
      const res = await apiGetConsecutivos();
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);
      setCons(list);
    } catch {
      toast.error("fn loadCons: Error cargando consecutivos");
    }
  };

  // ---- Select Consecutivo ----
  const loadConsById = async (id) => {
    try {
      const res = await getConsById(id);

      if (!res.success) {
        toast.error("Consecutivo no encontrada");
        return;
      }

      const c = res.data;

      setForm({
        id: c.id,
        Consecutivo: c.Consecutivo || "",
        api: c.Api || "",
        orden: c.Orden || "",
        estado: c.estado || 1,
        resultado: c.resultado || 0,
        api: c.Api || c.api || "",
        orden: c.Orden !== undefined ? c.Orden : (c.orden || 0),
        estado: c.Estado !== undefined ? c.Estado : (c.estado !== undefined ? c.estado : 1),
        resultado: c.resultado !== undefined ? c.resultado : (c.Resultado || 0),
        id_empresa: c.id_empresa !== undefined && c.id_empresa !== null ? c.id_empresa : 0,
      });
      setInactiveCons(true);

    } catch {
      toast.error("fn loadConsById: Error consultando consecutivo");
    }
  };

  const handleSelectCons = (id) => {
    setSelectedCons(id);
    loadConsById(id);
  };

  // ---- New  ----
  const handleNew = () => {
    setSelectedCons(null);
    setInactiveCons(false);
    setForm({
      id: "",
      Consecutivo: "",
      api: "",
      orden: "",
      estado: 1,
      resultado: 0,
      id_empresa: 0,
    });
  };

  // ---- Save  ----
  const saveCons = async () => {

    if (!form.Consecutivo || !form.api) {
      toast.error("Complete los campos obligatorios");
      return;
    }

    try {
      const res = await apiSaveCons(form);

      if (!res.success) {
        toast.error(res.message || "Error guardando ruta");
        return;
      }

      toast.success(res.message);
      loadCons();
      handleNew();
    } catch {
      toast.error("fn saveCons: Error guardando consecutivo");
    }
  };

  // Initial Load
  useEffect(() => {
    loadCons();
    empresaApi.getAll().then((res) => {
      setEmpresas(res.data || res || []);
    }).catch((err) => console.error(err));
  }, []);

  return {
    consecutivos,
    empresas,
    search,
    setSearch,
    selectedCons,
    form,
    setForm,
    handleNew,
    handleSelectCons,
    saveCons,
    loadCons,
    inactiveCons
  };
};
